export const MODULE_NAME = 'campaigns';
export const CAMPAIGNS_ROUTE = `/${MODULE_NAME}`;
